export default "/images/affe4e128382edaf4fbf665114ec57f4.png";